function FuseLoading() {
	return null;
}

export default FuseLoading;
